$(document).ready(function($) {
    var activeColor = 'blue';

    $('.testimonial-slider-outer-wrap').each(function() {
        if (!$(this).parents('.slider-wrapper').length) {
            //single set of testimonials
            var children = $(this).find('>.acf-innerblocks-container').children();
            var currentStyle = $(this).attr('style') ?? '';
            $(this).attr('style', currentStyle + '--quantity: ' + children.length + ';');
            children.each(function(index) {
                var currentStyle = $(this).attr('style') ?? '';
                $(this).attr('style', currentStyle + '--position: ' + (index + 1) + ';');
            });
            children.first().addClass('active');
            children.first().next(':not(.active)').addClass('next');
            children.find(':last-child:not(.active)').addClass('prev');

            children.find(':last-child:not(.active)').addClass(activeColor == 'blue' ? 'green' : 'blue');
            children.first().addClass(activeColor);
            children.first().next().addClass(activeColor == 'blue' ? 'green' : 'blue');
        }
    });

    $('.slider-wrapper').each(function() {
        $(this).append('<input type="hidden" class="activeColor" value="' + activeColor + '">');
        $(this).append('<input type="hidden" class="currentSlide" value="1">');
        var children = $(this).find('.testimonial-slider-outer-wrap >.acf-innerblocks-container').children();
        //add to the style tag the number of children
        var currentStyle = $(this).find('.testimonial-slider-outer-wrap').attr('style') ?? '';
        $(this).find('.testimonial-slider-outer-wrap').attr('style', currentStyle + '--quantity: ' + children.length + ';');
        children.each(function(index) {
            var currentStyle = $(this).attr('style') ?? '';
            $(this).attr('style', currentStyle + '--position: ' + (index + 1) + ';');
        });
        children.first().addClass('active');
        children.first().next().addClass('next').css('--active-position', '2');

        if (children.length > 2) {
            children.last().addClass('prev');
            children.last().addClass(activeColor == 'blue' ? 'green' : 'blue');
        } else {
            //clone the last child and add it to the slider
            var cloned = children.last().clone();
            cloned.addClass('prev cloned');
            cloned.addClass(activeColor == 'blue' ? 'green' : 'blue');
            cloned.attr('style', '--position: 0;').css('--active-position', '0');
            $(this).find('.testimonial-slider-outer-wrap >.acf-innerblocks-container').append(cloned);

        }

        children.first().addClass(activeColor).css('--active-position', '1');
        children.first().next().addClass(activeColor == 'blue' ? 'green' : 'blue');
        
        $(this).parents('.testimonial-slider-section').addClass('loaded');

        var dots = '';
        for (var i = 0; i < children.length; i++) {
            dots += '<a href="#" class="dot' + (i == 0 ? ' active' : '') + '">' + i + '</a>';
        }

        $(this).parents('.testimonial-slider-section').find('.slider-navigation .navigation-dots').html(dots);

    });

    var elementToShow = $('.testimonial-content.has-scroll-animation');
    var windowHeight = $(window).height();
    var offset = 100;
    elementToShow.each(function(){
        var $this = $(this);
        var top = $this.offset().top;
        var scroll = $(window).scrollTop();
        if (scroll + windowHeight >= top + offset) {
            $this.addClass('animated');
        }
    });

    $(window).on('scroll', function(){
        var elementToShow = $('.testimonial-content.has-scroll-animation');
        var windowHeight = $(window).height();
        var offset = 100;
        elementToShow.each(function(){
            var $this = $(this);
            var top = $this.offset().top;
            var scroll = $(window).scrollTop();
            if (scroll + windowHeight >= top + offset) {
                $this.addClass('animated');
            }
        });
    });
});